import { render, staticRenderFns } from "./LogoDescriptor.vue?vue&type=template&id=3e657db8&scoped=true&"
import script from "./LogoDescriptor.vue?vue&type=script&lang=js&"
export * from "./LogoDescriptor.vue?vue&type=script&lang=js&"
import style0 from "./LogoDescriptor.vue?vue&type=style&index=0&id=3e657db8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e657db8",
  null
  
)

export default component.exports